import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import BackgroundTile from './components/BackgroundTile';
import ContentPage from './components/utils/ContentPage';
import Footer from './components/Footer';
import portfolioJson from './portfolio.json';
import { useState } from 'react';
import axios from 'axios';

function App() {
    const [data, setData] = useState({});

    useEffect(() => {
            setData(portfolioJson.data);
        
    }, []);

    return (
        <div className='min-h-screen font-sans '>
            <BrowserRouter>
                <BackgroundTile />
                <ContentPage data={data} />
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
